export const getUserAvatar = (user) => {
    const { brand, homeOrganization } = user;
    return (brand?.logoUrl ||
        user.systemLogoUrl ||
        homeOrganization?.logoUrl ||
        brand?.cdnLogoUrl ||
        homeOrganization?.cdnLogoUrl);
};
